module.exports = __webpack_public_path__ + "img/Dantam Makeover 02.aec0074a.jpg";